import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { DocumentSupportArticleSelectTableModel } from 'src/app/models/shopping/document-support-article-select-table.model';
import { DocumentSupportDetailRegisterModel } from 'src/app/models/shopping/document-support-detail-register.model';
import { DocumentSupportDetailService } from 'src/app/services/shopping/document-support-detail.service';
import { DocumentSupportService } from 'src/app/services/shopping/document-support.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';
import { DocumentSupportDetailModel } from './../../../../models/shopping/document-support-detail.model';
import { DocumentSupportModel } from './../../../../models/shopping/document-support.model';

@Component({
  selector: 'app-document-support-detail',
  templateUrl: './document-support-detail.component.html',
  styleUrls: ['./document-support-detail.component.scss'],
  standalone: false
})
export class DocumentSupportDetailComponent implements OnInit {

  @ViewChild('selectArticle') articleModalComponent?: CustomModalComponent | null = null;

  @Input() disabledDetail: boolean = false;
  @Input() disabledActions: boolean = false;
  @Input() documentSupportModel: DocumentSupportModel = new DocumentSupportModel();
  @Input() quantityDetails: number = 0;
  @Input() updateListDetail: boolean = false;
  @Output() emitQuantityDetails = new EventEmitter<number>();
  @Output() updateDocumentSupport = new EventEmitter<DocumentSupportModel>();

  ascendant: boolean = true;
  ascendantArticle: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columnSortArticle: string | null = null;
  dataArticle: PagedResponseModel<DocumentSupportArticleSelectTableModel> = new PagedResponseModel<DocumentSupportArticleSelectTableModel>();
  detailData: PagedResponseModel<DocumentSupportDetailRegisterModel> = new PagedResponseModel<DocumentSupportDetailRegisterModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledButton: boolean = true;
  documentSupportDetail: DocumentSupportDetailModel = new DocumentSupportDetailModel();
  filtersArticle: ColumnResponseModel[] = [];
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelect$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: []
  });
  isFormView: boolean = false;
  isNewDetail: boolean = false;
  limit: number = 10;
  limitArticle: number = 5;
  output$ = new Subject<any>();
  page: number = 1;
  pageArticle: number = 1;
  subscription: Subscription;
  tableActions: TableAction[] = [];
  component = CustomTableSelectComponent;

  constructor(private documentSupportDetailService: DocumentSupportDetailService,
    private documentSupportService: DocumentSupportService,
    private toastHandlerService: ToastHandlerService) { }

  async ngOnInit(): Promise<void> {
    await this.getColumns();
    this.tableActions = this.getDefaultActions();

    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const documentSupportModel = changes["documentSupportModel"];
    if (documentSupportModel && !documentSupportModel.firstChange) {
      this.clearSelectionTrigger++;
      this.getFormView(false);
      this.getDocumentSupportDetailsByDocumentSupport();
      this.disabledButton = this.documentSupportModel.documentSupportId === 0 || this.documentSupportModel.active !== true ? true : false;
    }

    const disabledActions = changes["disabledActions"];
    if (disabledActions && !disabledActions.firstChange) {
      this.tableActions = this.disabledActions ? [] : this.getDefaultActions();
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  async clicDetail() {
    if (this.documentSupportModel.documentSupportId != 0) {
      this.isNewDetail = true;
      if (this.documentSupportDetail != null && this.isFormView == true) {
        this.isFormView = true;
      }
      this.isFormView = !this.isFormView;
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado del detalle.');
    }
  }

  async deleteDocumentSupportDetail(selectedIds: number[]) {
    if (selectedIds.length === 0) return;

    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea eliminar el detalle del documento soporte?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.documentSupportDetailService.deleteSomeDocumentSupportDetails(selectedIds));
        this.documentSupportDetail = new DocumentSupportDetailModel();
        this.clearSelectionTrigger++;
        this.getUpdateListDetail();
        this.toastHandlerService.showToast('success', 'El detalle del documento soporte fue eliminado exitosamente.');
      } catch (error) {
        console.error('Error al eliminar el detalle deel documento soporte.', error);
      }
    }
  }

  async getAllArticlesForSelect() {
    try {
      this.dataArticle = await firstValueFrom(
        this.documentSupportDetailService.getArticlesForDocumentSupport(this.documentSupportModel.documentSupportId, this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle)
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de articulos.', error);
    }
  }

  async getColumns() {
    try {
      if (this.detailHeader.length == 0)
        this.detailHeader = await firstValueFrom(this.documentSupportDetailService.getColumnsForDetailCapture());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getColumnsArticle() {
    try {
      if (this.headerArticle.length === 0) {
        this.headerArticle = await firstValueFrom(this.documentSupportDetailService.getColumnsForArticleCaptureDocumentSupport());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      }
    ];
  }

  async getDocumentSupport() {
    const documentSupport = await firstValueFrom(this.documentSupportService.getDocumentSupportById(this.documentSupportModel.documentSupportId));
    this.updateDocumentSupport.emit(documentSupport);
  }

  async getDocumentSupportDetailsByDocumentSupport() {
    try {
      this.detailData = await firstValueFrom(this.documentSupportDetailService.getDocumentSupportDetailsByDocumentSupport(this.page, this.limit, this.columnSort, this.ascendant,
        this.documentSupportModel.documentSupportId));
      this.emitQuantityDetails.emit(this.detailData.totalItems);
    } catch (error) {
      console.error('Error al buscar los detalles del documento soporte.', error);
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async handleSelectedItems(selectedItems: any) {
    if (selectedItems.length == 1) {
      const articleId = parseInt(selectedItems[0]?.articleId);
      const response = await firstValueFrom(
        this.documentSupportDetailService.getDocumentSupportDetailByKeys(this.documentSupportModel.documentSupportId, articleId));
      if (response.documentSupportDetailId === 0) {
        this.documentSupportDetail = new DocumentSupportDetailModel();
        this.documentSupportDetail.documentSupportId = this.documentSupportModel.documentSupportId;
        this.documentSupportDetail.articleId = articleId;
      } else {
        this.documentSupportDetail = response;
      }
    } else {
      const documentSupportDetails: DocumentSupportDetailModel[] = []
      selectedItems.forEach((element: { articleId: number; storeId: number; }) => {
        const newDocumentSupportDetail = new DocumentSupportDetailModel();
        newDocumentSupportDetail.documentSupportId = this.documentSupportModel.documentSupportId;
        newDocumentSupportDetail.articleId = element.articleId;
        documentSupportDetails.push(newDocumentSupportDetail);
      });

      await firstValueFrom(this.documentSupportDetailService.createDetailsDocumentSupport(documentSupportDetails, this.documentSupportModel.documentSupportId));
      this.toastHandlerService.showToast('success', 'El detalle de la remisión fue creado exitosamente', '');
      this.getDocumentSupportDetailsByDocumentSupport();
    }
  }

  async onAction(event: { action: string, item?: DocumentSupportDetailModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      const response = await firstValueFrom(this.documentSupportDetailService.getDocumentSupportDetailByDocumentSupportId(event.item!.documentSupportDetailId));
      if (response)
        this.documentSupportDetail = response;
      this.getFormView(true);
    }
    if (event.action === 'bulk-delete' && event.selectedItems) {
      this.deleteDocumentSupportDetail(event.selectedItems);
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getDocumentSupportDetailsByDocumentSupport();
  }

  async getUpdateListDetail() {
    this.getDocumentSupportDetailsByDocumentSupport();
    this.getDocumentSupport();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    this.getAllArticlesForSelect();
  }

  async openModal() {
    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsArticle(),
      this.getAllArticlesForSelect()]
    );
    this.updateInputs();
    this.articleModalComponent && this.articleModalComponent.show();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  updateInputs() {
    this.inputsForArticlesSelect$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          action: 'view-image',
          label: 'Imágenes',
          icon: 'pi pi-image'
        }
      ]
    });
  }
}
